module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "checkout"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 text-center"
  }, [(_vm.order && _vm.order.status === 'Accepted') ? _c('div', [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Order went through successfully!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n            You should receive a confirmation email very shortly"), (_vm.user && _vm.user.email) ? [_vm._v(" on "), _c('strong', [_vm._v(_vm._s(_vm.user.email))])] : _vm._e(), _vm._v(".\n            Enjoy your food and do not forget to come back to let us know how it was!\n          ")], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Order Number:")]), _vm._v(" #" + _vm._s(_vm.order.order_number))]), _vm._v(" "), (_vm.order.type === 'delivery' && _vm.order.delivery_address) ? _c('p', [_c('strong', [_vm._v("Delivering to:")]), _vm._v(" " + _vm._s(_vm.order.delivery_address)), (_vm.order.delivery_postcode) ? [_vm._v(", " + _vm._s(_vm.order.delivery_postcode))] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-danger btn-fill",
    attrs: {
      "to": "/",
      "tag": "button"
    }
  }, [_vm._v("\n            Check more products\n          ")])], 1) : (_vm.order) ? _c('div', [_c('h2', {
    staticClass: "section-title text-red"
  }, [_vm._v("Order was not successful!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n            Unfortunately there has been an error while trying to process your payment."), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.order.status_message))])]), _vm._v(" "), _c('p', [_vm._v("We advise you to go back to checkout and try again.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-danger btn-fill",
    attrs: {
      "to": "/checkout",
      "tag": "button"
    }
  }, [_vm._v("\n            Go back to checkout\n          ")])], 1) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('u', [_vm._v("Error message:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-502e04ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/checkout/response.vue
// module id = 550
// module chunks = 1